import React, { useState } from 'react';
import './WebDevelopment.css';

const WebDevelopment = ({ setCurrentPage, setPageData }) => {
  const [activeTab, setActiveTab] = useState('all');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    serviceType: 'website-hosting',
    details: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [expandedFaq, setExpandedFaq] = useState(null);

  const EMAIL = 'Info@transcontinentalnetwork.com';
  const PHONE_NUMBER = '347.668.2160';

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
  };

  const handleEmailClick = () => {
    const subject = encodeURIComponent('Inquiry: Web Development & Hosting Services');
    const body = encodeURIComponent(`Hi Transcontinental Network Team,\n\nI am interested in your Web Development and Hosting services.\n\nName: ${formData.name}\nPhone: ${formData.phone}\nService Type: ${formData.serviceType}\n\nDetails:\n${formData.details}`);
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${encodeURIComponent(EMAIL)}&su=${subject}&body=${body}`;
    window.open(gmailUrl, '_blank', 'noopener,noreferrer');
  };

  const servicesList = [
    {
      id: 'web-dev',
      category: 'development',
      icon: (
        <svg viewBox="0 0 24 24" width="36" height="36" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6"></polyline>
          <polyline points="8 6 2 12 8 18"></polyline>
        </svg>
      ),
      title: 'Custom Web Development',
      description: 'Bespoke websites and web applications built from scratch with modern frameworks like React, Node.js, and HTML5/CSS3. Fast, responsive, and tailored to your brand identity.',
      features: ['Modern React & Next.js Stack', 'Mobile-Responsive Layouts', 'SEO & Performance Optimized', 'Clean & Scalable Codebase']
    },
    {
      id: 'hosting',
      category: 'hosting',
      icon: (
        <svg viewBox="0 0 24 24" width="36" height="36" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
          <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
          <line x1="6" y1="6" x2="6.01" y2="6"></line>
          <line x1="6" y1="18" x2="6.01" y2="18"></line>
        </svg>
      ),
      title: 'Managed Cloud Web Hosting',
      description: 'Ultra-reliable cloud hosting with 99.9% uptime guarantee, free SSL encryption, automated daily backups, and custom domain setup for maximum reliability.',
      features: ['99.9% Uptime SLA', 'Free SSL Security Certificate', 'Automated Daily Backups', 'Enterprise Email & Domain Setup']
    },
    {
      id: 'ecommerce',
      category: 'development',
      icon: (
        <svg viewBox="0 0 24 24" width="36" height="36" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
      ),
      title: 'E-Commerce & Online Stores',
      description: 'Turnkey e-commerce solutions with secure payment gateways (Stripe, PayPal), real-time inventory management, product catalogs, and intuitive checkout flows.',
      features: ['Payment Gateway Integration', 'Product & Order Management', 'Customer Account Portals', 'Mobile Checkout Optimization']
    },
    {
      id: 'redesign',
      category: 'development',
      icon: (
        <svg viewBox="0 0 24 24" width="36" height="36" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 20h9"></path>
          <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
        </svg>
      ),
      title: 'Website Redesign & Modernization',
      description: 'Transform outdated websites into modern, sleek digital platforms that captivate visitors, boost conversion rates, and dramatically speed up page loading.',
      features: ['Modern UX/UI Design Refreshes', 'Core Web Vitals Speed Boost', 'Mobile User Experience Overhaul', 'SEO Structure Migration']
    },
    {
      id: 'security',
      category: 'hosting',
      icon: (
        <svg viewBox="0 0 24 24" width="36" height="36" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
      ),
      title: 'Website Security & Malware Protection',
      description: 'Enterprise-grade website security including DDoS protection, web application firewall (WAF), real-time malware monitoring, and immediate patch deployment.',
      features: ['Web Application Firewall (WAF)', 'DDoS Defense & Mitigation', 'Malware Scanning & Cleaning', 'Proactive Core Updates']
    },
    {
      id: 'maintenance',
      category: 'hosting',
      icon: (
        <svg viewBox="0 0 24 24" width="36" height="36" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
        </svg>
      ),
      title: '24/7 Support & Site Maintenance',
      description: 'Comprehensive monthly maintenance plans covering content updates, bug fixes, database tuning, uptime monitoring, and direct developer phone/email support.',
      features: ['Dedicated Developer Support', 'Regular Content & Image Updates', 'Uptime & Speed Monitoring', 'Monthly Analytics Reports']
    }
  ];



  const faqs = [
    {
      question: 'Do you provide both web development and website hosting?',
      answer: 'Yes! We offer complete end-to-end solutions. We design and build your website from scratch and host it on our high-speed managed cloud infrastructure with SSL, domain configuration, and backups included.'
    },
    {
      question: 'How long does it take to create a new website?',
      answer: 'Standard business websites typically take 1 to 2 weeks to complete. Larger e-commerce or custom web applications range from 2 to 4 weeks depending on specific features and requirement complexity.'
    },
    {
      question: 'Can you migrate my existing website to your hosting?',
      answer: 'Absolutely. We provide seamless website migration with zero downtime. Our team will transfer your files, databases, domains, and business emails hassle-free.'
    },
    {
      question: 'Will my website work well on mobile phones and tablets?',
      answer: '100% yes. Every website we build is fully responsive, mobile-first, and optimized for ultra-fast loading speed across all smartphones, tablets, and modern desktop browsers.'
    },
    {
      question: 'Can I update the website content myself after launch?',
      answer: 'Yes, we provide user-friendly management options, or you can take advantage of our monthly maintenance plan where our developers handle all text, image, and feature updates for you.'
    }
  ];

  const filteredServices = activeTab === 'all' 
    ? servicesList 
    : servicesList.filter(s => s.category === activeTab);

  return (
    <div className="webdev-page">
      {/* Hero Section */}
      <section className="webdev-hero">
        <div className="webdev-hero-bg-glow"></div>
        <div className="container">
          <div className="webdev-hero-badge fade-in">
            <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
            NEW SERVICE OFFERING
          </div>
          <h1 className="webdev-hero-title fade-in">
            Custom Web Development <br />
            <span className="text-gradient">&amp; Managed Hosting</span>
          </h1>
          <p className="webdev-hero-subtitle fade-in">
            Empowering your business with high-performance websites, custom web applications, 
            and bulletproof 99.9% uptime cloud hosting—all managed by local NYC professionals.
          </p>
          <div className="webdev-hero-cta fade-in">
            <a href="#quote-section" className="btn-webdev-primary">
              <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
              Get Free Quote
            </a>
            <a href="#services-grid" className="btn-webdev-secondary">
              Explore Services
            </a>
            <a href={`tel:${PHONE_NUMBER.replace(/\./g, '')}`} className="btn-webdev-outline">
              <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              {PHONE_NUMBER}
            </a>
          </div>

          {/* Quick Stat Pill Cards */}
          <div className="webdev-stats-strip">
            <div className="stat-pill">
              <span className="stat-value">99.9%</span>
              <span className="stat-label">Uptime SLA</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-pill">
              <span className="stat-value">&lt; 1s</span>
              <span className="stat-label">Lightning Fast Load</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-pill">
              <span className="stat-value">SSL Free</span>
              <span className="stat-label">HTTPS Security</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-pill">
              <span className="stat-value">24/7</span>
              <span className="stat-label">Managed Protection</span>
            </div>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="webdev-intro section">
        <div className="container">
          <div className="webdev-intro-grid">
            <div className="webdev-intro-text">
              <span className="sub-tag">END-TO-END DIGITAL SOLUTIONS</span>
              <h2>Why Your Business Needs Professional Web Creation &amp; Hosting</h2>
              <p>
                A fast, modern website is the digital storefront of your enterprise. At <strong>Transcontinental Network</strong>, 
                we extend our expertise in technology infrastructure to build robust, secure, and modern websites tailored to your exact business goals.
              </p>
              <p>
                Whether you need a sleek company website, a high-converting online store, or zero-stress cloud hosting that keeps 
                your site up 24/7, we handle everything—from design and development to domain registration, SSL certificates, and daily maintenance.
              </p>
              <div className="webdev-check-list">
                <div className="check-item">
                  <svg viewBox="0 0 24 24" width="20" height="20" stroke="#0d9488" strokeWidth="2.5" fill="none"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  <span>Custom React &amp; Modern Framework Architecture</span>
                </div>
                <div className="check-item">
                  <svg viewBox="0 0 24 24" width="20" height="20" stroke="#0d9488" strokeWidth="2.5" fill="none"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  <span>High-Speed SSD Managed Cloud Hosting</span>
                </div>
                <div className="check-item">
                  <svg viewBox="0 0 24 24" width="20" height="20" stroke="#0d9488" strokeWidth="2.5" fill="none"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  <span>Automated Daily Backups &amp; Malware Defense</span>
                </div>
                <div className="check-item">
                  <svg viewBox="0 0 24 24" width="20" height="20" stroke="#0d9488" strokeWidth="2.5" fill="none"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  <span>Search Engine Optimization (SEO) &amp; Speed Tuning</span>
                </div>
              </div>
            </div>

            <div className="webdev-intro-visual">
              <div className="code-window-card">
                <div className="window-header">
                  <span className="dot red"></span>
                  <span className="dot yellow"></span>
                  <span className="dot green"></span>
                  <span className="window-title">transcontinental-webdev.config.js</span>
                </div>
                <div className="window-body">
                  <pre>
                    <code>
{`const webService = {
  client: "Your Enterprise",
  stack: ["React", "Node.js", "SSL", "Cloud CDN"],
  hosting: {
    uptime: "99.9%",
    backups: "Daily Automated",
    security: "WAF + DDoS Protection"
  },
  seoOptimized: true,
  mobileResponsive: true,
  status: "ONLINE & ACCELERATED ✓"
};`}
                    </code>
                  </pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section id="services-grid" className="webdev-services-section section">
        <div className="container">
          <div className="section-header-center">
            <span className="sub-tag">OUR SERVICES</span>
            <h2 className="section-title">Comprehensive Web Development &amp; Hosting Services</h2>
            <p className="section-subtitle">
              Choose from custom web creation, full-featured e-commerce stores, or managed cloud hosting plans.
            </p>

            <div className="filter-tabs">
              <button 
                className={`tab-btn ${activeTab === 'all' ? 'active' : ''}`}
                onClick={() => setActiveTab('all')}
              >
                All Services
              </button>
              <button 
                className={`tab-btn ${activeTab === 'development' ? 'active' : ''}`}
                onClick={() => setActiveTab('development')}
                style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
              >
                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="16 18 22 12 16 6"></polyline>
                  <polyline points="8 6 2 12 8 18"></polyline>
                </svg>
                Web Development &amp; Design
              </button>
              <button 
                className={`tab-btn ${activeTab === 'hosting' ? 'active' : ''}`}
                onClick={() => setActiveTab('hosting')}
                style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
              >
                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
                  <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
                  <line x1="6" y1="6" x2="6.01" y2="6"></line>
                  <line x1="6" y1="18" x2="6.01" y2="18"></line>
                </svg>
                Hosting &amp; Cloud Security
              </button>
            </div>
          </div>

          <div className="webdev-card-grid">
            {filteredServices.map((service) => (
              <div key={service.id} className="service-feature-card">
                <div className="card-icon-wrapper">
                  {service.icon}
                </div>
                <h3 className="card-title">{service.title}</h3>
                <p className="card-desc">{service.description}</p>
                <ul className="card-feature-list">
                  {service.features.map((feat, idx) => (
                    <li key={idx}>
                      <span className="bullet-icon">✓</span>
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Request Form Section */}
      <section id="quote-section" className="webdev-quote-section section">
        <div className="container">
          <div className="quote-box">
            <div className="quote-box-header">
              <span className="sub-tag-light">GET STARTED TODAY</span>
              <h2>Request a Free Web Development or Hosting Quote</h2>
              <p>Tell us about your project or hosting needs. Our team will get back to you within 24 hours with a custom proposal.</p>
            </div>

            {formSubmitted ? (
              <div className="quote-success-card">
                <div className="success-icon" style={{ color: '#0d9488', display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                  <svg viewBox="0 0 24 24" width="64" height="64" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                </div>
                <h3>Thank You for Your Request!</h3>
                <p>We have received your web development &amp; hosting inquiry. Our local engineering team will review your specifications and reach out shortly.</p>
                <div className="success-actions">
                  <button className="btn-webdev-primary" onClick={handleEmailClick}>
                    Send Details via Gmail / Email Client
                  </button>
                  <button className="btn-webdev-secondary" onClick={() => setFormSubmitted(false)}>
                    Submit Another Request
                  </button>
                </div>
              </div>
            ) : (
              <form className="quote-form" onSubmit={handleFormSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input 
                      type="text" 
                      name="name" 
                      required 
                      placeholder="e.g. John Doe"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input 
                      type="email" 
                      name="email" 
                      required 
                      placeholder="e.g. john@example.com"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input 
                      type="tel" 
                      name="phone" 
                      required 
                      placeholder="e.g. (347) 000-0000"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Required Service *</label>
                    <select 
                      name="serviceType" 
                      value={formData.serviceType}
                      onChange={handleInputChange}
                    >
                      <option value="website-hosting">New Website + Managed Hosting</option>
                      <option value="web-development-only">Custom Web Development</option>
                      <option value="hosting-only">Cloud Hosting &amp; Domain Setup</option>
                      <option value="ecommerce">E-Commerce Store</option>
                      <option value="redesign">Website Redesign &amp; Speed Boost</option>
                      <option value="maintenance">Monthly Security &amp; Maintenance</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Project Details / Requirements</label>
                  <textarea 
                    name="details" 
                    rows="4" 
                    placeholder="Describe your website goals, number of pages, design preferences, or current hosting setup..."
                    value={formData.details}
                    onChange={handleInputChange}
                  ></textarea>
                </div>

                <div className="form-submit-row">
                  <button type="submit" className="btn-submit-quote" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                    <span>Submit Quote Request</span>
                    <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                  </button>
                  <button type="button" className="btn-direct-email" onClick={handleEmailClick}>
                    Direct Email Inquiry
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="webdev-faq-section section">
        <div className="container">
          <div className="section-header-center">
            <span className="sub-tag">GOT QUESTIONS?</span>
            <h2 className="section-title">Frequently Asked Questions</h2>
            <p className="section-subtitle">Everything you need to know about our web development and hosting services.</p>
          </div>

          <div className="faq-accordion">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${expandedFaq === index ? 'open' : ''}`}
                onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
              >
                <div className="faq-question">
                  <h3>{faq.question}</h3>
                  <span className="faq-icon">{expandedFaq === index ? '−' : '+'}</span>
                </div>
                {expandedFaq === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Direct Contact Banner */}
      <section className="webdev-contact-banner" style={{ textAlign: 'center', padding: '60px 20px' }}>
        <div className="container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
          <div className="banner-flex" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', maxWidth: '800px', margin: '0 auto', width: '100%' }}>
            <div className="banner-text" style={{ textAlign: 'center', marginBottom: '20px' }}>
              <h2 style={{ textAlign: 'center', fontSize: '1.8rem', fontWeight: '800', marginBottom: '10px', color: '#0f172a' }}>
                Need Immediate Assistance or Have Custom Requirements?
              </h2>
              <p style={{ textAlign: 'center', color: '#475569', fontSize: '1.05rem', margin: 0 }}>
                Speak directly with our local NYC tech team today.
              </p>
            </div>
            <div className="banner-actions" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
              <a href={`tel:${PHONE_NUMBER.replace(/\./g, '')}`} className="btn-banner-call" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <span>Call {PHONE_NUMBER}</span>
              </a>
              <a href={`https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${encodeURIComponent(EMAIL)}`} target="_blank" rel="noopener noreferrer" className="btn-banner-email" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <span>Email {EMAIL}</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WebDevelopment;
